import { Box } from '@mui/material'
import Base from '../../../Base/views/Base'
import BioMetricGrid from '../Team/BioMetricGrid'

const TeamTimeExecutivePage = () => {
  return (
    <Base>
    <Box sx={{ maxHeight: "calc(100vh - 75px)", overflowY: "auto" }}>
      <BioMetricGrid lmsExecutive={true} />
    </Box>
    </Base>
  )
}

export default TeamTimeExecutivePage